import React, { useEffect, useState } from "react";
import axios from "axios";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import logo from '../../app/assets/img/preloader1.gif';
import { useParams } from "react-router-dom";
import { getToken } from "../../app/auth/authConfig";

const PowerBiReport = ({pagename}) => {
  const [powerbiReport, setPowerbiReport] = useState({});
  const [loading, setLoading] = useState(true);
  const [powerbiLoading, setpowerbiLoading] = useState(true);

  const { reportnewid } = useParams();

  const powerbiReportData = async () => {
    try {
      const baseurl = `${process.env.REACT_APP_BACKEND_API_URL}/api/tools/embed/${reportnewid}`;
      const token = await getToken();

      const response = await axios.get(baseurl,{
        headers: { "oidc-token": token },
      });

      // Handling the response
      if (response.status === 200) {
        console.log("token generated successfully:", response.data);
        setLoading(false);
        setPowerbiReport(response.data);
        return response.data;
      } else {
        console.error(
          "Error posting FAQ data:",
          response.status,
          response.statusText
        );
        setLoading(false);
      }
    } catch (error) {
      console.error("Error posting FAQ data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    powerbiReportData();
  }, []);

  const embdData = (embeddedReport) => {
    window.report = embeddedReport;
    window.report.on("loaded", async function () {
      var reportPages = await window.report.getPages();
    });
  };

  const token = powerbiReport.embedToken;
  const url = powerbiReport.reportURL;
  const reportGId = powerbiReport.reportGuid;

  return (
    <div>
      <div style={{ height: "85vh" }}>
        {powerbiLoading && (
          <div
            style={{
              position: "absolute",
              background: "#ffffff",
              height: "100%",
              left: "0",
              right: "0",
              top: "0",
              bottom: "0",
              overflow: "hidden",
              borderRadius:"10px"
            }}
          >
            <div
              style={{
                display: "grid",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                height: "100%",
                overflow: "hidden",
                gap: "1rem",
              }}
            >
              <img src={logo} alt="logo" width={100}/>

              <span style={{color:"white"}}>Please wait...</span>
            </div>
          </div>
        )}

        {!loading && (
          <>
            <PowerBIEmbed
              embedConfig={{
                type: "report", // Supported types: report, dashboard, tile, visual, qna, paginated report and create
                id: reportGId,
                embedUrl: url,
                accessToken: token,
                pageName:`${pagename}`,
                tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
            
                settings: {
                  // navContentPaneEnabled:false,
                  panes: {
                    filters: {
                      expanded: false,
                      visible: false,
                    },

                  },
                  // background: models.BackgroundType.Transparent,
                },
              }}
              eventHandlers={
                new Map([
                  [
                    "loaded",
                    function () {
                      console.log("Report loaded");
                      setpowerbiLoading(false);
                    },
                  ],
                  [
                    "rendered",
                    function () {
                      console.log("Report rendered");
                    },
                  ],
                  [
                    "error",
                    function (event) {
                      console.log(event.detail);
                    },
                  ],
                  ["visualClicked", () => console.log("visual clicked")],
                  ["pageChanged", (event) => console.log(event)],
                ])
              }
              cssClassName={"report-style-class"}
              getEmbeddedComponent={embdData}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default PowerBiReport;
